import * as amplitude from '@amplitude/analytics-node';
import { SECOND } from 'core/common/constants';
import { CookiesService } from 'core/common/services/cookie';
import { generateUUID } from 'core/common/utils/generateUUID';
import {
  EventValue,
  EventProperties,
  EventUserProperty,
  ExtendedEventValue,
  isExtendedEvent,
} from '../../entities';
import { AmplitudeService } from '../../interfaces';

export class AmplitudeServerService implements AmplitudeService {
  private deviceId?: string;
  private readonly deviceIdCookieName = 'device_id';

  constructor(apiKey: string, private readonly cookiesService: CookiesService) {
    amplitude.init(apiKey, {
      flushIntervalMillis: SECOND,
      flushQueueSize: 10,
    });

    this.deviceId = this.setDeviceId();
  }

  private setDeviceId(): string {
    const deviceId = this.cookiesService.get(this.deviceIdCookieName);

    if (!deviceId) {
      const newDeviceId = generateUUID();

      this.cookiesService.set(this.deviceIdCookieName, newDeviceId, { path: '/' });

      return newDeviceId;
    }

    return deviceId;
  }

  logEvent(eventName: string, properties?: EventProperties): void {
    amplitude.track(eventName, properties, {
      device_id: this.deviceId,
    });
  }

  trackEvent(event: EventValue, properties?: EventProperties): void {
    if (isExtendedEvent(event)) {
      this.trackExtendedEvent(event, properties);
      return;
    }

    this.logEvent(event, properties);
  }

  private trackExtendedEvent(event: ExtendedEventValue, properties?: EventProperties): void {
    this.logEvent(event.name, { ...event.properties, ...properties });
  }

  setUserProperties(userData: Record<string, EventUserProperty>): void {
    const identifyObj = new amplitude.Identify();

    Object.entries(userData).forEach(([key, value]) => {
      identifyObj.set(key, value);
    });

    amplitude.identify(identifyObj, { device_id: this.deviceId });
  }

  setUserExperimentGroupName(experimentName: string, groupName: string): void {
    this.setUserProperties({
      [experimentName]: groupName,
    });
  }

  funnelOpened(): void {
    return;
  }
  flowOpened(): void {
    return;
  }
  trackUserLanguage(): void {
    return;
  }
  launch(): void {
    return;
  }
  getDeviceId(): string {
    return '';
  }
  getSessionId(): string {
    return '';
  }

  setUserId(): void {
    return;
  }
  setUserEmail(): void {
    return;
  }
  setUserIdProperty(): void {
    return;
  }
  policyPageOpened(): void {
    return;
  }
  faqPageOpened(): void {
    return;
  }
  contactUsPageOpened(): void {
    return;
  }
  paymentCardClick(): void {
    return;
  }
  googlePayClick(): void {
    return;
  }
  applePayClick(): void {
    return;
  }
  paypalPayClick(): void {
    return;
  }
  paymentCardChosen(): void {
    return;
  }
  appleBtnChosen(): void {
    return;
  }
  googleBtnChosen(): void {
    return;
  }
  paymentPaypalChosen(): void {
    return;
  }
  paymentError(): void {
    return;
  }
  paymentRetried(): void {
    return;
  }
  paymentSuccess(): void {
    return;
  }
  emailUpsellScreenOpen(): void {
    return;
  }
  purchaseSucceed(): void {
    return;
  }
  purchaseError(): void {
    return;
  }
  setUserAge(): void {
    return;
  }
  setFeatureFlagsAttributes(): void {
    return;
  }
}
